import axios, { AxiosError } from 'axios';

declare module 'axios' {
  interface AxiosRequestConfig {
    normalizeError?: boolean;
  }
}

export type NormalizedError = {
  success: false;
  code: number;
  correctedEmail?: string;
};

export const normalizeError = (error: AxiosError<{ code?: number; correctedEmail?: string }>): NormalizedError => {
  const data = error?.response?.data;
  return {
    success: false,
    code: data?.code || 0,
    ...(data?.correctedEmail && { correctedEmail: data.correctedEmail }),
  };
};

export const httpClient = axios.create({
  baseURL: '',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

httpClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error?.config?.normalizeError === false) {
      return Promise.reject(error);
    }
    return Promise.reject(normalizeError(error));
  }
);
